<template>
  <div class="paddBottom">
    <IndexHeaderOthers ref="indexHeader"></IndexHeaderOthers>
    <div class="main">
      <div class="conner">
        <div class="conner-top">
          <el-table
              :data="tableData"
              style="width: 100%"
              @row-click="clickData"
          >
            <el-table-column
                fixed
                prop="title"
                label="Title"
                width="150">
            </el-table-column>
            <el-table-column
                prop="objectClass"
                label="ObjectClass"
                width="120">
            </el-table-column>
            <el-table-column
                prop="tagNames"
                label="TagNames"
                width="200">
            </el-table-column>
            <el-table-column
                prop="triggerTime"
                label="TriggerTime"
                width="120">
            </el-table-column>
            <el-table-column
                prop="objectName"
                label="ObjectNAME"
                width="200">
            </el-table-column>
            <el-table-column
                prop="createDate"
                label="SubTime"
                width="120">
            </el-table-column>
            <el-table-column
                prop="email"
                label="Sub-Email"
                width="120">
            </el-table-column>
            <el-table-column
                prop="status"
                label="Status"
                width="120">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.status==='0'" >待审批</el-tag>
                <el-tag v-if="scope.row.status==='1'"  type="success">审批通过</el-tag>
                <el-tag v-if="scope.row.status==='2'"  type="danger">未通过</el-tag>
                <el-tag v-if="scope.row.status==='4'"  type="success">审批通过</el-tag>
                <el-tag v-if="scope.row.status==='5'"  type="success">暂存</el-tag>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pageBlock">
          <CuntPage
              :totalTwo="total"
              :pageSize="pageSize"
              @handleCurrentChanges="handchange"
              @handleSizeChange="sizeChange"
              :currentPage="pageNo"
              ref="cuntPage"
          ></CuntPage>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IndexHeaderOthers from "./header/indexHeaderOthers.vue";
import CuntPage from "../components/page/CuntPage";
export default {
  name: "submitList",
  components:{
    IndexHeaderOthers,
    CuntPage,
  },
  data(){
    return{
      tableData: [],
      //翻页有关字段
      total:100,
      pageSize:10,
      pageNo: 1,
      userid:'',
      userInfo:{},

    };
  },
  mounted(){
    //初始化数据
    //获取用户信息
    this.userInfo = localStorage.getItem('userInfo');
    if (this.userInfo==null){
      this.userid='';
      this.$message({text:"You have not logged in to the system, please go to the user center to log in!",type:"error"});
      this.$router.push("/indexPage");
    }else {
      this.userid=JSON.parse(localStorage.getItem('userInfo')).cstnetId;
    }
    this.getData(this.pageNo,this.pageSize,"");

  },
  methods:{
    handchange(e, type) {
      this.pageNo = e;
      this.getData(e, this.pageSize);
    },
    sizeChange(e) {
      this.pageSize = e;
      this.getData(this.pageNo, e);
    },
    //获取数据
    getData(pageNo, pageSize, type) {
      this.$fetchPost("/cms-middle/astronCustomize/getSubmitDataList", {
        userid: this.userid,
        pageSize: pageSize,
        page: pageNo,
      }).then((res) => {
        res.data.forEach(item=>{
          const dateTime=item.createDate;
          const date = new Date(dateTime);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1，并且补齐两位数
          const day = String(date.getDate()).padStart(2, '0'); // 补齐两位数
          const hours = String(date.getHours()).padStart(2, '0'); // 补齐两位数
          const minutes = String(date.getMinutes()).padStart(2, '0'); // 补齐两位数
          const seconds = String(date.getSeconds()).padStart(2, '0'); // 补齐两位数
          const formattedDate = year+'-'+month+'-'+day+" "+hours+":"+minutes+":"+seconds;
          item.createDate=formattedDate;
        });
        this.tableData=res.data;
        this.total=res.total;

      }).catch((err) => {

      });
    },
    clickData(row, event, column) {
      const status=row.status;
      const id=row.id;
      if (status=="5"){
        this.$router.push({path:'submit',query:{constid:row.id}});
        // this.$router.push({path:'showSubmitInfo',query:{constid:row.id}});
      }else {
        this.$router.push({path:'submit',query:{constid:row.id}});
      }

    },
  }
};
</script>

<style lang="less">
.paddBottom{
  padding-bottom: 0px;
}
.conner {
  width: 1150px;
  margin: 0 auto;
  text-align: left;
}
.conner-top {
  padding-top: 48px;
  display: flex;
}
.main {
  position: relative;
  margin-top: -70px;
  z-index: 99;
  width: 100%;
  height: auto;
  background: #fff;
  border-radius: 0 120px 0 0;
}
.pageBlock {
  margin-top: 28px;
  height: 44px;
  display: flex;
  align-items: center;
  margin-bottom: 52px;
}
</style>